import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useMemo,
} from "react";

import RTBillsTab from "components/RTBills/RTBillsTab";
import RTBills from "components/RTBills/Bills/RTBills";
import RTDashboard from "components/RTBills/Dashboard/RTDashboard";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import { ErrorBoundary } from "react-error-boundary";
import { Redirect, useLocation } from "react-router-dom";
import RTBudget from "components/RTBills/Budget/RTBudget";
import {
  Navigate,
} from "react-router-dom";
import postPageVisit from "services/LogService";

export default function Bills() {
  // console.log("Page plan d'actions");
  const [redirState, setRedirState] = useState(false);
  const appContext = useContext(AdvancedSearchContext);
  const { setPage } = appContext;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [selectedTab, setSelectedTab] = useState('');
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const currentusertype = localStorage.getItem('userType');
  const options = JSON.parse(localStorage.getItem('memoptions')) || [];

  useEffect(() => {
    let selected = '0';
    if (params && params.get("tab") === 'budget') {
      selected = '2';
    }
    else if (params && params.get("tab") === 'dashboard') {
      selected = '1';
    }
    else
      selected = '0';

    if (currentusertype != 1 && !(options && options.find((x) => x.id === 'bills') && permis && permis.includes('bills_access')))
      selected = '2';
    else if (currentusertype != 1 && !(options && options.find((x) => x.id === 'budget') && permis && permis.includes('budget_access')))
      selected = '0';

    setSelectedTab(selected);
    setPage('bills');
    postPageVisit('bills');
  }, []);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: location.pathname,
      }}
    />
  );
  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"bills"}
    >
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          <Card>
            <CardBody>
              <RTBillsTab bills={<RTBills />} budget={<RTBudget />} dashboard={<RTDashboard />} selectedTab={selectedTab} />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {redirecting}
    </ErrorBoundary>
  );
}
